export default {
    getLocation(callback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callback,(ex) => {
                console.log(ex);
                switch(ex.code) {
                    case ex.PERMISSION_DENIED:
                        alert('您拒绝了位置共享请求。');
                        break;
                    case ex.POSITION_UNAVAILABLE:
                        alert('位置信息不可用。');
                        break;
                    case ex.TIMEOUT:
                        alert('请求位置超时。');
                        break;
                    default:
                        alert("定位失败:" + JSON.stringify(ex.message));
                }
                callback(null);
            });
        } else {
            console.log("navigator.geolocation is null");
            callback(null);
        }
    }
}
